import { Button, Paper } from "@mui/material";
import {
    useFeatureFlags,
    useSetFeatureFlags,
} from "components/providers/featureFlags/useFeatureFlags";
import CONSTANTS from "src/constants";
import { Sx } from "utils/sx";

const styles: Sx = (theme) => ({
    position: "fixed",
    bottom: 82,
    left: 0,
    margin: theme.spacing(1),
    zIndex: theme.zIndex.tooltip + 1,
    boxShadow: theme.shadows[1],
});

export const FeatureFlagsToggle = () => {
    const enabled = useFeatureFlags();
    const { toggle } = useSetFeatureFlags();
    
    const isDev = CONSTANTS.DEV;
    const isStaging = window.location.hostname.includes("staging.liveheats");
    const isProd = !isDev && !isStaging;
    
    const searchParams = new URLSearchParams(window.location.search);
    const isButtonDisabled = searchParams.get("no-flags") !== null;

    if (isProd || isButtonDisabled) return null;

    return (
        <Paper sx={styles}>
            <Button
                onClick={toggle}
                data-testid={enabled ? "flags-enabled" : "flags-disabled"}
                variant={enabled ? "contained" : "text"}
                color="secondary"
                size="small"
                data-is-enabled={enabled}
            >
                Feature Flags
            </Button>
        </Paper>
    );
};
